module.exports = __webpack_public_path__ + "static/img/header8.46abcd35.jpg";